import { useRef } from 'react';

export type ElementSelectorFunction = () => HTMLElement[];

export function useEqualHeights(selector: ElementSelectorFunction) {
    const elements = useRef<HTMLElement[]>([]);

    function clear() {
        elements.current.forEach(element => void (element.style.height = 'auto'));
        elements.current = [];
    }

    function resize() {
        elements.current = selector();
        const heights = elements.current.map(el => el.offsetHeight);
        const maxHeight = Math.max(...heights);
        elements.current.forEach(el => (el.style.height = `${maxHeight}px`));
    }

    return { clear, resize };
}
